import {
  ApiOption_Local_getInstance3qz3xgeh0kmmi as ApiOption_Local_getInstance,
  ApiOption_SameServer_getInstance2ipdc4gluvj3e as ApiOption_SameServer_getInstance,
  ApiOption_Dev_getInstance95677x1au46r as ApiOption_Dev_getInstance,
  ApiOption_Production_getInstanceubmglnekim4q as ApiOption_Production_getInstance,
  ApiOption_Staging_getInstanceh0ucumoveaak as ApiOption_Staging_getInstance,
} from './apiOptions.mjs';
import { contains3ue2qo8xhmpf1 as contains } from '../../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function getDefaultServerBackend() {
  var host = window.location.hostname;
  return contains(host, 'staging') ? ApiOption_Staging_getInstance() : contains(host, 'thecommunitygroupinc.org') ? ApiOption_Production_getInstance() : contains(host, 'lightningkite') ? ApiOption_Dev_getInstance() : contains(host, 'localhost') ? ApiOption_SameServer_getInstance() : ApiOption_Local_getInstance();
}
//region block: exports
export {
  getDefaultServerBackend as getDefaultServerBackend23eva9cd76aqs,
};
//endregion

//# sourceMappingURL=apiOptions.js.mjs.map
